require('jquery-confirm')

const defaultSettings = {
  animation        : 'zoom',
  backgroundDismiss: true,
  closeAnimation   : 'zoom',
  draggable        : false,
  smoothContent    : false,
  theme            : 'modern',
  typeAnimated     : false,
  useBootstrap     : false,
}

class deleteScholarshipsConfirm {
  _construct() {
    this.$btnsDeleteScholarship = document.querySelectorAll('.btn--delete-scholarship');
  }

  _deleteScholarship($el) {
    const content = '<p>Esta acción no se puede deshacer</p>'

    let deleteScholarshipOptions = {
      content: content,
      icon    : 'fas fa-exclamation-circle x:fs-50',
      title   : '¿Seguro de querer eliminar esta solicitud?',
      type    : 'blue',
      buttons : {
        confirm: {
          text: 'Aceptar',
          btnClass: 'btn btn-primary',
          action: function() {
            let $form = $el.closest('form');
            $form.submit();
          }
        },
        cancel: {
          text: 'Cancelar',
          btnClass: 'btn btn-secondary',
          action: function() {
            this.close();
          }
        }
      }
    }

    deleteScholarshipOptions = $.extend(defaultSettings, deleteScholarshipOptions)

    $.confirm(deleteScholarshipOptions)
  }

  init() {
    this._construct();
    let self = this;

    self.$btnsDeleteScholarship.forEach(function($button) {
      $button.addEventListener('click', function(event) {
        event.preventDefault();
        // --
        self._deleteScholarship($button);
      });
    });
  }
}

export default deleteScholarshipsConfirm
